const _ = require('lodash');
const categoryPidMap = new Map();
let _loginService, _shopperService;

function setAll(categories, isSpecial) {
    if (isSpecial) {
        // pointer at specials
        this.specials = categories.rawResponse;
        this.categories = this.specials;
    } else {
        // pointer at products
        this.products = categories.rawResponse;
        this.categories = this.products;
    }

    return categories;
}

function getAll(isSpecial) {
    /// <summary>
    /// Returns a promise that will be filled with the list of category objects.
    /// </summary>
    /// <returns type=""></returns>
    if (isSpecial) {
        this.specialsInvalidated = false;
    } else {
        this.invalidated = false;
    }

    this.loaded = this._api.getList({ IsSpecials: isSpecial })
        .then(_.partialRight(setAll, isSpecial).bind(this));

    return this.loaded;
}

function CategoriesService(rootScope, $state, restangular, $q, breakpointsService, loginService, shopperService, bootstrap, pageMetadataService, $timeout, featureService) {
    const self = this;
    self.$rootScope = rootScope;
    self._api = restangular.all('categories');
    self.breakpointsService = breakpointsService;

    self.aisleName = $state.params.aisle;
    self.departmentName = $state.params.category;
    self.$state = $state;
    self.$q = $q;

    self.products = [];
    self.specials = [];
    self.categories = [];

    self.isSpecial = false;
    self.currentCategory = {};

    self.pageMetadataService = pageMetadataService;
    self.$timeout = $timeout;
    self.isHomepageEnabled = featureService.isEnabled(featureService.features.homepageOnSmallFormat);
    self.previousCategoryBeforeRestricted = {};

    _loginService = loginService;
    _shopperService = shopperService;

    if (bootstrap.isBootstrapped(bootstrap.bootstrapped.Categories)) {
        this.invalidated = false;
        setAll.call(this, bootstrap.getBootstrappedData(bootstrap.bootstrapped.Categories));
    }

    if (bootstrap.isBootstrapped(bootstrap.bootstrapped.SpecialsCategories)) {
        this.specialsInvalidated = false;
        setAll.call(this, bootstrap.getBootstrappedData(bootstrap.bootstrapped.SpecialsCategories), true);
    }

    rootScope.$on('address-update', () => {
        this.invalidate(false);
    });

    rootScope.$on('login:success', (e, loginResult, loginPrompt) => {
        this.invalidate(loginPrompt.willRedirect);
    });
}

CategoriesService.prototype.hasCurrentCategory = function () {
    return !_.isEmpty(this.currentCategory) && this.currentCategory.department;
};

/**
 * Try to find a given category in the current categories and return it
 * if the category exists.
 * @param {String} parentUrlName - The UrlFriendlyName of the category to search for.
 * @returns {bool} - False if the given categories doesn't exist, else return the category.
 */
CategoriesService.prototype.categoryExists = function (urlName) {
    const category = _.find(this.categories, { UrlFriendlyName: urlName });
    return category || false;
};

CategoriesService.prototype.getAll = function (isSpecial) {
    const deferred = this.$q.defer();
    if (isSpecial) {
        if (this.specials.length > 0 && !this.specialsInvalidated) {
            this.categories = this.specials;
            deferred.resolve(this.specials);
            return deferred.promise;
        }

        return getAll.call(this, isSpecial);
    }
    if (this.products.length > 0 && !this.invalidated) {
        this.categories = this.products;
        deferred.resolve(this.products);
        return deferred.promise;
    }

    return getAll.call(this, isSpecial);
};

function goToCategoryState(relativeState, data, location, notify) {
    this.$state.transitionTo(relativeState, data, { location, notify });
}

function getLoginPromise(targetState, data) {
    return this.breakpointsService.isInSmallFormat
        ? _loginService.promptForLogin(_loginService.LoginToViewCategoryMessage, targetState, data)
        : _loginService.promptForLogin(_loginService.LoginToViewCategoryMessage);
}

CategoriesService.prototype.updateUrl = function (isBrowserButtonEvent, isReplace, resetQueryParams, landingOptions, stateOptions) {

    // change state
    const location = isReplace ? 'replace' : !isBrowserButtonEvent;
    const currentState = this.$state.$current.self.name;
    let targetState;

    if (stateOptions && stateOptions.state) {
        targetState = stateOptions.state;
    } else {
        // What relative state should we go to
        const relativeState = this.$state.params.category ? '.' : '.category.aisle';

        // Determine the absolute state so that we can check if it exists TODO: separate selected category from url
        targetState = currentState + (relativeState === '.' ? '' : relativeState);
    }

    let data;
    // if we are on the landing section
    if (!this.currentCategory.department || !this.currentCategory.aisle) {
        data = { id: undefined, name: undefined }; // reset query string for card detail
        goToCategoryState.call(this, landingOptions.state, data, location, landingOptions.label, false);
        return;
    }

    // get the name of the category/aisle and url encode them
    const categoryName = this.currentCategory.department.UrlFriendlyName;
    const aisleName = this.currentCategory.aisle.UrlFriendlyName;
    data = { category: categoryName, aisle: aisleName };
    if (resetQueryParams || !this.breakpointsService.isInSmallFormat) {
        data.id = undefined;
        data.name = undefined;
    }

    // Check if the state that we're trying to navigate to exists
    if (this.$state.get(targetState)) {
        if (this.currentCategory.aisle.IsRestricted && _shopperService.currentUser.isGuest) {
            getLoginPromise.call(this, targetState, data)
                .catch(() => {
                    this.updateServiceState();
                    this.$rootScope.$broadcast('categories:change', { currentCategory: this.currentCategory });
                });
        } else {
            let notify = false;
            if (targetState === 'shop.specials.browse.category.aisle' && this.breakpointsService.isInSmallFormat) {
                notify = true;
            }
            const self = this;
            goToCategoryState.call(this, targetState, data, location, self.currentCategory.aisle.Name, notify);
        }
    }
};

CategoriesService.prototype.updateServiceState = function (stateOptions, landingOptions) {
    const department = _.find(this.categories, category => category.UrlFriendlyName === this.$state.params.category);
    let aisle;
    let stateParams;
    if (department) {
        if (stateOptions && !this.$state.params[stateOptions.category]) {
            aisle = _.head(department.ChildCategories);

            stateParams = {};
            stateParams[stateOptions.category] = department.UrlFriendlyName;
            stateParams[stateOptions.subCategory] = aisle.UrlFriendlyName;

            this.$state.go(
                stateOptions.state,
                stateParams,
                { location: 'replace' }
            );
        }

        aisle = _.find(department.ChildCategories, category => category.UrlFriendlyName === this.$state.params.aisle);
    }

    if (department && aisle) {
        this.currentCategory.department = department;
        this.currentCategory.aisle = aisle;
    } else if (landingOptions && landingOptions.label.length > 0 && this.$state.current.name === landingOptions.state) {
        this.currentCategory.department = undefined;
        this.currentCategory.aisle = undefined;
    } else if (this.categories.length > 0) {
        this.currentCategory.department = this.categories[0];
        this.currentCategory.aisle = this.categories[0].ChildCategories[0];

        if (this.$state.current.name === 'shop.browse.category.aisle') {
            this.$state.go('shop.browse.category.aisle', { category: this.currentCategory.department.UrlFriendlyName, aisle: this.currentCategory.aisle.UrlFriendlyName });
        }
    }
};

CategoriesService.prototype.getCategory = function (departmentIndex, aisleIndex) {
    return this.categories[departmentIndex].ChildCategories[aisleIndex];
};


CategoriesService.prototype.getCategoryByName = function (aisleName, categoryName) {
    const department = _.find(this.categories, function (category) { return category.UrlFriendlyName === aisleName; });
    let aisle;
    if (department) {
        aisle = _.find(department.ChildCategories, function (childCategory) { return childCategory.UrlFriendlyName === categoryName; });
    }

    return {
        department: department || {},
        aisle: aisle || {}
    };
};

CategoriesService.prototype.setSelectedCategory = function (selectedDepartment, selectedAisle, isBrowserEvent, resetQueryParams, landingOptions) {

    if (!selectedDepartment) {
        if (landingOptions && landingOptions.label.length > 0) { // if there is a landing section then the default become the landing
            this.currentCategory.department = undefined;
            this.currentCategory.aisle = undefined;
            this.updateUrl(isBrowserEvent, undefined, resetQueryParams, landingOptions);
        } else { // else the default is the first department and aisle
            this.currentCategory.department = this.categories[0];
            this.currentCategory.aisle = this.categories[0].ChildCategories[0];
        }
        return;
    }

    if (!selectedAisle) {
        this.currentCategory.department = selectedDepartment;
        this.currentCategory.aisle = selectedDepartment.ChildCategories[0];
        return;
    }

    if (this.currentCategory.department !== selectedDepartment || this.currentCategory.aisle !== selectedAisle) {
        this.currentCategory.department = selectedDepartment;
        this.currentCategory.aisle = selectedAisle;

        this.updateUrl(isBrowserEvent, undefined, resetQueryParams);
    }
};

CategoriesService.prototype.selectCategory = function (departmentIndex, aisleIndex, isBrowserEvent, resetQueryParams, landingOptions) {
    const selectedDepartment = this.categories[departmentIndex];
    const selectedAisle = selectedDepartment.ChildCategories[aisleIndex];
    this.setSelectedCategory(selectedDepartment, selectedAisle, isBrowserEvent, resetQueryParams, landingOptions);
};

CategoriesService.prototype.invalidate = function (willRedirect) {
    this.invalidated = true;
    this.specialsInvalidated = true;
    const previousCategory = this.isHomepageEnabled && !_shopperService.currentUser.isGuest && !_shopperService.AllowRestrictedDepartment && this.currentCategory.aisle && this.currentCategory.aisle.IsRestricted
        ? this.previousCategoryBeforeRestricted
        : this.currentCategory;
    this.currentCategory = {};

    this.$rootScope.$broadcast('categories:invalidated', { previousCategory, willRedirect });
};

CategoriesService.prototype.setPidList = function (categoryID, resultPidList) {
    let pidList = categoryPidMap.get(categoryID) || [];
    if (resultPidList.length) {
        pidList = [...pidList, ...resultPidList];
        categoryPidMap.set(categoryID, pidList);
    }

    if (!pidList.length) categoryPidMap.set(categoryID, null);
};

CategoriesService.prototype.getPidList = function (categoryID) {
    return categoryPidMap.get(categoryID);
};

module.exports = CategoriesService;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/categories/categories-service.js
 **/